// ------------------------------------------------------------------------------
// name: routes
// author: mudas
// created: 2025/5/27
// ------------------------------------------------------------------------------

// 定义基础路由枚举
export enum NormalRoutes {
  LOGIN = 'login',
  UPLOAD = 'upload',

  SETTING = 'setting',
  TASK = 'task',
  TASK_ENTRUST = 'task/entrust',
  TASK_PLATFORM = 'task/platform',
  MY_BIDDING = 'my-bidding',
  HANDLING_BIDDING_TASK = 'handling-bidding-task',
  BIDDING_TASKS_MARKET = 'bidding-tasks-market',
  BIDDING_TASK_DETAIL = 'bidding-task-detail',
  VERSION_DETAIL = 'home',
  LOGIN_ERROR = 'login-error',
  ADD_VERSION = 'add-version',
  MODEL_LIBRARY = 'model-library',
  MY_SALES = 'my-sales',
  MY_INFO = 'my-info',
  NESTED_TASK_DETAIL = 'nested-task-detail', // 父需求详情页
  HOME = 'portal',
  BIND_PHONE = 'bind-phone',
  PROTOCOL_UPDATE = 'protocol-update',
  ARTIST_HOME = 'artist-home',
  MEDIA_USER_HOME = 'media-user-home',
  ARTIST_LIST = 'artist-list',
  UPLOAD_ASSET = 'upload-asset',
  MESSAGE_BOX = 'message-box',
  USER_PREFERENCE = 'user-preference',
  CHOOSE_ROLE = 'choose-role',
  ARTIST_AUTH = 'artist-auth',
  CLOUD_DESKTOP = 'cloud-desktop',
  TASK_PUBLISH = 'task-publish',
  TASK_PUBLISH_PREV = 'task-publish-prev',
  TASK_UPDATE = 'task-update',
  TASK_PUBLISH_SUCCESS = 'task-publish-success',
  NICKNAME_SETTING = 'nickname-setting',
  PLATFORM_UPDATE = 'platform-update',

  CONTRACT_READING = 'contract-reading',
  OWN_ARTIST = 'own-artist',
  SHARE_ARTIST = 'share-artist',
  OPENID_LOGIN = 'openid-login',
  APP_LOGIN = 'app-login',
  BOARD_LOGIN = 'board-login',
  PREVIEW_MODEL = 'preview-model',

  PREVIEW_MEDIA_ARTWORKS = 'preview-media-artworks',
  APP_DOWNLOAD = 'app-download',

  MY_ACTIVITY = 'my-activity',
  EXTERNAL_WEBSITE = 'external-website',
  CONTRACT_SERVICE = 'contract-service',
  COMFYUI_AUTH = 'comfyui-auth',
}

// 定义活动路由枚举
export enum ActivitiesRoutes {
  ACTIVITY = 'activity', // 活动中心路由
}

// 合并所有路由到一个对象
export const ROUTER_PATHNAME = {
  ...NormalRoutes,
  ...ActivitiesRoutes,
} as const;

// 定义路由路径名称类型
export type ROUTER_PATHNAME = NormalRoutes | ActivitiesRoutes;
